import * as React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import theme from 'theme';
import t from 'utils/translations';

const NavListItem = styled.li`
    a.active {
        background-color: ${theme.colors.main_light};
        border-right: 4px solid ${theme.colors.main};
        color: ${theme.colors.main};
        font-family: ${theme.fonts.medium};
    }

    a {
        transition: border 0.23s;
        border-right: 4px solid transparent;
        padding: 15px 50px;
        color: ${theme.colors.text};
        font-size: 16px;
        display: block;
    }

    svg {
        margin: 0 15px 0 0;
    }

    &:hover a {
        border-right: 4px solid ${theme.colors.main};
    }
`;

const SubHeading = styled.h4`
    padding: 15px 50px;
    margin: 20px 0 10px;
    text-transform: uppercase;
    font-family: ${theme.fonts.regular};
    color: ${theme.colors.gray_lighter};
`;

interface NavItem {
    title: string;
    path: string;
    icon: IconProp;
    external?: boolean;
}

export const navItems: NavItem[] = [
    { title: t('DASHBOARD'), path: '/', icon: ['far', 'briefcase'] },
    {
        title: t('PICK'),
        path: '/poiminta',
        icon: ['far', 'hand-receiving']
    },
    {
        title: t('GROUPS'),
        path: '/ryhmat',
        icon: ['far', 'users']
    }
];

export default function Tools() {
    return (
        <>
            <SubHeading>{t('TOOLS')}</SubHeading>
            <ul>
                {navItems.map(link => (
                    <NavListItem key={link.title}>
                        <NavLink
                            exact={link.path === '/'}
                            to={link.path}
                            activeClassName="active"
                            isActive={(match, location) => {
                                if (match) {
                                    return true;
                                }
                                // This makes the /ryhmat link active when navigated in different group subsections
                                if (
                                    link.path === '/ryhmat' &&
                                    (location.pathname.includes('/ryhma') ||
                                        location.pathname.includes(
                                            '/kategoria'
                                        ))
                                ) {
                                    return true;
                                }

                                return false;
                            }}
                        >
                            <FontAwesomeIcon icon={link.icon} />
                            {link.title}
                        </NavLink>
                    </NavListItem>
                ))}
            </ul>
        </>
    );
}
